import { PLAN_NAMES } from './plansConfig';

export const getCurrentPlanConfig = () => ({
  currentPlan: PLAN_NAMES.PRO,
  addOnQuantities: {
    actions: 3,
    aiCredits: 5,
  },
  originalQuantities: {
    actions: 3,
    aiCredits: 5,
  },
  pendingChanges: {
    plan: PLAN_NAMES.FREE,
    addOns: {
      actions: 1,
      aiCredits: 2,
    },
  },
  showPendingChanges: true,
  nextBillingDate: new Date(Date.now() + 30 * 24 * 60 * 60 * 1000),
  animations: {
    actions: null,
    aiCredits: null,
  },
  isEditing: false,
  downgradeDialogOpen: false,
});

export default getCurrentPlanConfig;
